import { useTranslation } from 'react-i18next';

import { useForumPosts } from '~/api/forum/useForumPosts';

import { ForumPosts } from '../components/ForumPosts';
import { useForumTagFilter } from '../Forum.nuqs';

export const ForumTimeline = () => {
  const [tag] = useForumTagFilter();
  const query = useForumPosts(tag);

  const { t } = useTranslation(['forum']);

  return (
    <ForumPosts
      emptyMessage={t('forum:overview.timeline.empty')}
      errorMessage={t('forum:overview.timeline.error.title')}
      page="timeline"
      query={query}
    />
  );
};
